import { render, staticRenderFns } from "./TableColumnManager.vue?vue&type=template&id=33bb8145&scoped=true&"
import script from "./TableColumnManager.vue?vue&type=script&lang=js&"
export * from "./TableColumnManager.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnManager.vue?vue&type=style&index=0&id=33bb8145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb8145",
  null
  
)

export default component.exports